import React, { useState, useEffect } from "react";
import { Paper, Typography, useTheme, useMediaQuery } from "@mui/material";

import apiService from "../../../ApiService";
import { API_ENDPOINTS } from "../../../ApiService";
import { MainContainer } from "../styles/sharedStyles";
import Title from "../../components/title/Title";
import Section from "../../components/section/Section";
import { tokens } from "../../../theme";
import ClientTable from "../../components/overviewOfAllClients/ClientTable";

// Extracted style for the heading
const headingStyle = {
  backgroundColor: "#1976d2",
  color: "#fff",
  p: 1,
  borderRadius: 1,
};

const OverviewClientsPage = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <MainContainer>
      <Title title="Clients" summary="Liste de tous les clients" />
      <Section>
        <Paper
          elevation={3}
          sx={{
            p: 1.5, // smaller padding
            mb: 2,
            backgroundColor: colors.primary[400],
          }}
        >
          <Typography variant="body1" color={colors.grey[100]} align="left">
            Tous les clients actuellement en coaching.
          </Typography>
        </Paper>
      </Section>
      <ClientTable />
    </MainContainer>
  );
};

export default OverviewClientsPage;
